export const SAVE_ALL_SERVICE_OCCURRENCES = 'SAVE_ALL_SERVICE_OCCURRENCES'